<template>
    <v-card class="pb-4">
      <v-toolbar dense flat>
        <v-toolbar-title>Import Upbit</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs12>
            <ol class="subheading" style="line-height: 2em">
              <li class="list-item">Go to <a target="_blank" href="https://upbit.com/exchange">https://upbit.com/exchange</a> and login.</li>
              <li class="list-item">Open <b>Console</b> on browser. (Press <b>Commannd + Option + J</b> for Mac)</li>
              <li class="list-item">
                <div>Run following command and copy the result</div>
                <code>prompt('Access Token', /{"accessToken":"(.+)","tokenType"/.exec(document.cookie)[1])</code>
              </li>
              <li class="list-item">Put the <b>Access Token</b> below.</li>
            </ol>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              v-model="form.jwt"
              :disabled="loading"
              label="Access Token"
              prepend-icon="mdi-lock"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-autocomplete
              v-model="form.accounts"
              label="Accounts"
              :items="accounts"
              item-text="account_id"
              return-object
              :search-input.sync="accountSearch"
              :disabled="!accounts.length || loading"
              prepend-icon="mdi-account"
              multiple
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.date"
              :value="form.date"
              :disabled="!form.accounts.length || loading"
              label="Date"
              type="datetime-local"
              step="1"
              required
              prepend-icon="mdi-timer"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn :disabled="!valid || loading" :loading="loading" color="primary" @click="submit">Submit</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MessageDialog from '../../libs/message-dialog/'
import MongoConnector from '../../services/mongo-connector.service'
import { getDefaultConnectorSchema } from '../../configs/schemas'
import { merge } from 'lodash'
import { parseFormInputValue } from '../../libs/utils'
import moment from 'moment'
export default {
  data() {
    const defaultDate = moment.utc().subtract(1, 'day').toDate()
    return {
      loading: true,
      form: {
        jwt: undefined,
        accounts: [],
        date: parseFormInputValue(Date, defaultDate)
      },
      botConfigsService: new MongoConnector(getDefaultConnectorSchema(null, 'bot-configs')),
      accounts: [],
      accountSearch: undefined
    }
  },
  async beforeMount () {
    await this.init()
  },
  computed: {
    valid () {
      return !this.loading && this.form.jwt && this.form.accounts && this.form.accounts.length && !isNaN(+new Date(this.form.date))
    }
  },
  methods: {
    async init () {
      this.loading = true
      this.accounts = await this.getAccounts()
      this.loading = false
    },
    async getAccounts () {
      return this.botConfigsService.find({
        filter: { account_id: { $regex: '_upbit', $options: 'g' } },
        sort: { account_id: 1, exchange: 1 },
        projection: { account_id: 1, exchange: 1 },
        limit: 1000
      })
    },
    async submit () {
      this.loading = true
      try {
        const { jwt, accounts, date } = this.form
        const result = []
        for (const account of accounts) {
          try {
            const response = await MongoService.api.historicalTradeExecutions({
              'method': 'import-upbit',
              jwt,
              'account': account.account_id,
              'lastTrade': {
                'date': moment.utc(date).toDate()
              }
            })
            result.push({ 'account': account.account_id, response })
          } catch (error) {
            result.push({ 'account': account.account_id, response: error.toString() })
          }
        }
        MessageDialog.showSuccessMessage(
          this.parseNotificationResult({
            notificationName: `Import Upbit Result`,
            message: result
              .map(({ account, response }) => `<b>${account}</b><br>${JSON.stringify(response, null, 2)}`)
              .join('<br>==========================================<br>')
          })
        )
      } catch (error) {
        MessageDialog.showErrorMessage({ text: error.toString() })
      }
      this.loading = false
    },
    parseNotificationResult ({ notificationName, message }) {
      return {
        width: '80%',
        html: `
          <div class='v-card theme--dark green lighten-1'>
            <div class='v-card__title title'>${notificationName}</div>
            <div class='v-card__text white black--text grey lighten-5'><pre>${message}</pre></div>
          </div>`
      }
    }
  }
}
</script>

<style scoped>
.list-item {
  padding-left: 0.5em;
}
</style>
